<template>
  <div class="biz-web-player" v-resize="onResize">
    <c-loading v-if="loading" tip="加载中..."></c-loading>
    <template v-else>
      <div class="view" ref="view">
        <iframe v-if="currentPage"
                ref="player"
                :src="pageSrc"
                :style="frameStyle"></iframe>
        <canvas ref="canvas"
                class="view-over"
                :style="canvasStyle"
                :width="frameRect.width * frameRect.scale"
                :height="frameRect.height * frameRect.scale"></canvas>
        <c-loading v-if="!pageReady" tip="加载中..."></c-loading>
      </div>
      <div class="foot">
        <control-bar :duration="info.lastEvent - info.firstEvent"
                     :page-ready="pageReady"
                     :loadProcess="(loadedCount / info.eventCount) * 100"
                     @replay="onReplay"
                     @setProcess="setProcess"
                     @process="onProcess" ref="controlBar"></control-bar>
        <div class="event-panel">
          <event-node v-for="(event, i) in store.eventList"
                      :event="event"
                      :play-time="playTime"
                      @click="onClickEvent"
                      @hover="onHoverEvent"
                      @leave="onLeaveEvent"
                      :key="event.eventId + '-' + i"></event-node>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ControlBar from './controlBar'
import EventNode from './eventNode'
import io from 'socket.io-client'
/**
 * web视屏播放器
 */
/**
 * {
 *   $eid: '',
 *   $page: '',
 *   $pix: '',
 *   screenHeight: Number,
 *   screenWidth: Number,
 *   time: Number,
 *   sc: Number
 * }
 */
let frames = []
let socket = null
export default {
  name: 'WebPlayer',
  components: {EventNode, ControlBar},
  props: {
    /**
     * 数据源, 事件列表
     */
    store: {
      type: Object,
      default () {
        return {
          /**
           * {
           *   eventId: Number,
           *   did: String,
           *   eventName: String,
           *   markStatus: Number,
           *   time: Number
           * }
           */
          eventList: []
        }
      }
    },
    /**
     * @description iframe视图的域名地址
     */
    playOrigin: {
      type: String,
      default: 'http://111.231.195.117:3001'
    },
    /**
     * @description 会话id
     */
    sid: {
      // type: Number,
      required: true
    },
    /**
     * @description 应用id
     */
    appKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      currentPage: null,
      eventList: this.$util.clone(this.store.eventList), // 业务事件列表
      pageReady: false,
      loading: true,
      interval: {
        setProcess: null
      },
      recordSize: { // 录制视频时，页面窗口的大小
        width: 0,
        height: 0
      },
      frameRect: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        scale: 0
      },
      info: null,
      loadedCount: 0, // 已加载的event数量
      playTime: 0, // 当前播放的时间
      a: 0 // iframe中url的参数，该参数只有一个作用，就是重新播放时，改变改参数使iframe重新加载页面
    }
  },
  computed: {
    pageSrc () {
      return `${this.playOrigin}/view/ak/${this.appKey}/did/${this.store.did}/sid/${this.sid}/page/${this.currentPage.$page}?a=${this.a}`
    },
    frameStyle () {
      let style = {
        width: this.frameRect.width + 'px',
        height: this.frameRect.height + 'px',
        top: `${this.frameRect.top}px`,
        left: `${this.frameRect.left}px`,
        transform: `scale(${this.frameRect.scale})`,
        '-webkit-transform': `scale(${this.frameRect.scale})`
      }
      return style
    },
    canvasStyle () {
      return {
        top: `${this.frameRect.top}px`,
        left: `${this.frameRect.left}px`
      }
    },
    /**
     * @description 视屏事件第一个事件的触发时间
     */
    beginTime () {
      if (!frames.length) return 0
      return this.$util.clone(frames[0].time)
    }
  },
  watch: {
    store: {
      handler () {
        this.eventList = this.$util.clone(this.store.eventList)
        this.onResize()
      },
      deep: true
    },
    playOrigin () {
      this.reload()
    },
    sid () {
      this.reload()
    },
    appKey () {
      this.reload()
    }
  },
  beforeMount () {
    this.initSocket()
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    reload () {
      let controlBar = this.$refs.controlBar
      if (controlBar) controlBar.reset()
      this.loadedCount = 0
      this.playTime = 0
      this.a = 0
      this.destroy()
      this.initSocket()
      this.init()
      this.onReplay()
      this.eventList = this.$util.clone(this.store.eventList)
    },
    init () {
      window.onmessage = event => {
        if (event.data === 'pageReady') {
          this.pageReady = true
          this.send({
            $eid: 'scroll',
            $pix: JSON.stringify({
              target: 0,
              scrollTop: this.currentPage.scrollTop,
              scrollLeft: this.currentPage.scrollLeft
            })
          })
          this.onResize()
        }
      }
    },
    destroy () {
      window.onmessage = null
      if (socket) {
        socket.disconnect()
        socket.destroy()
      }
      socket = null
      frames = []
    },
    initSocket () {
      socket = io(this.playOrigin.replace('https', 'wss').replace('http', 'ws'), {
        path: '/socket',
        query: {
          appKey: this.appKey,
          sessionId: this.sid,
          did: this.store.did,
          role: 'player'
        }
      })
      socket.on('event', event => {
        event = JSON.parse(event)
        if (event.events) {
          event.events.forEach(item => {
            let _ = {
              $eid: item.$eid,
              $page: item.$page,
              $pix: item.$pix,
              screenWidth: event.$wh[0],
              screenHeight: event.$wh[1],
              time: item.time,
              sc: event.$sc
            }
            let props = ['scrollTop', 'scrollLeft', 'parentPageId']
            props.forEach(prop => {
              if (event[prop] !== undefined) _[prop] = event[prop]
            })
            frames.push(_)
          })
        } else {
          let _ = {
            $eid: event.$eid,
            $page: event.$page,
            $pix: event.$pix,
            screenWidth: event.$wh[0],
            screenHeight: event.$wh[1],
            scrollTop: event.scrollTop,
            scrollLeft: event.scrollLeft,
            time: event.$ct,
            sc: event.$sc
          }
          let props = ['scrollTop', 'scrollLeft', 'parentPageId']
          props.forEach(prop => {
            if (event[prop] !== undefined) _[prop] = event[prop]
          })
          frames.push(_)
        }
        if (!this.currentPage) {
          this.currentPage = this.$util.clone(frames[0])
        }
        this.loadedCount++
      })
      socket.on('info', info => {
        this.info = info
        this.loading = false
      })
      socket.on('close', () => {
        this.loadedCount = this.info.eventCount
        socket.disconnect()
        socket.destroy()
        socket = null
      })
    },
    /**
     * @description 向视图窗口传递播放到的事件
     */
    send (event) {
      let frame = this.$refs.player
      if (!frame) return
      frame.contentWindow.postMessage(event, this.playOrigin)
    },
    /**
     * @description 获取frame窗口的视图信息
     */
    getFrameRect () {
      let view = this.$refs.view
      if (!view || !this.currentPage) return {}
      // 减去的20，是padding值
      const viewRect = {
        width: view.getBoundingClientRect().width - 20,
        height: view.getBoundingClientRect().height - 20
      }
      const pageRect = {
        width: this.recordSize.width || this.currentPage.screenWidth,
        height: this.recordSize.height || this.currentPage.screenHeight
      }
      let scale = Math.min(viewRect.width / pageRect.width, viewRect.height / pageRect.height)
      // 加20是因为，absolute定位不受padding影响
      let rect = {
        width: pageRect.width,
        height: pageRect.height,
        top: (viewRect.height + 20 - pageRect.height * scale) / 2,
        left: (viewRect.width + 20 - pageRect.width * scale) / 2,
        scale
      }
      return rect
    },
    /**
     * @description resize事件监听
     */
    onResize () {
      this.resize()
    },
    /**
     * @description resize处理（供外部调用）
     */
    resize () {
      this.frameRect = this.getFrameRect()
    },
    /**
     * 播放进度发生变化时触发
     * @param processTime 已播放时间
     * @description 播放过的事件，标记played为true
     * todo 播放到缓存进度时自动暂停播放
     */
    onProcess (processTime) {
      let time = this.playTime = this.beginTime + processTime
      frames.forEach((event) => {
        if (event.time > time || event.played) return // 如果还没播放到该事件或者已播放事件，直接跳过
        switch (event.$eid) {
          case 'page':
            if (this.currentPage.$page !== event.$page) {
              this.pageReady = false
              this.a++
            }
            this.currentPage = this.$util.clone(event)
            break
          case 'click':
            this.drawMouse(event)
            break
          case 'resize':
            this.recordSize = JSON.parse(event.$pix)
            this.onResize()
            break
          default:
            if (event.$eid === 'hover') {
              this.drawMouse(event)
            }
            this.send(event)
        }
        event.played = true
      })
    },
    /**
     * @description 重新播放事件监听
     */
    onReplay () {
      frames.forEach(event => { // 事件状态重置
        event.played = false
      })
      this.pageReady = false
      this.currentPage = this.$util.clone(frames[0])
      this.a += 1
    },
    /**
     * @description 进度条拖动事件监听
     */
    setProcess (process) {
      let time = this.beginTime + process // 定位的时间节点
      let needPlayEvents = [] // 需要重新执行的事件
      let nearPage = null // 定位时间节点最近的一个page
      frames.forEach(event => {
        if (event.time <= time) { // 小于定格时间的事件，从最近的一次page事件开始重新执行
          if (event.$eid === 'page') { // 每次重新定义页面及事件区域，减少不必要的事件执行
            nearPage = event
            needPlayEvents.forEach(item => { // 历史页面的事件，不用重新播放，直接修复为已播放状态即可
              item.played = true
            })
            needPlayEvents = []
          }
          event.played = false
          needPlayEvents.push(event)
        } else if (event.played) { // 大于定格时间的，且已播放过的事件，还原播放状态
          event.played = false
        }
      })
      if (nearPage === this.currentPage) { // 如果就是当前页面，则iframe页面刷新一下
        this.pageReady = false
        this.a += 1
      }
      this.interval.setProcess = setInterval(() => {
        if (this.pageReady) {
          this.onProcess(needPlayEvents[needPlayEvents.length - 1].time - this.beginTime)
          clearInterval(this.interval.setProcess)
        }
      }, 100)
    },
    clearCanvas () {
      let ctx = this.$refs.canvas.getContext('2d')
      ctx.clearRect(0, 0, this.frameRect.width * this.frameRect.scale, this.frameRect.height * this.frameRect.scale)
    },
    drawMouse (event) {
      this.clearCanvas()
      let ctx = this.$refs.canvas.getContext('2d')
      let position = JSON.parse(event.$pix).position
      const scale = this.frameRect.scale
      ctx.beginPath()
      ctx.fillStyle = 'rgba(252,203,23,0.5)'
      ctx.arc(position[0] * scale, position[1] * scale, 30 * scale, 0, 2 * Math.PI)
      ctx.fill()
      ctx.closePath()
    },
    onClickEvent (event) {
      this.setProcess(event.time - this.info.firstEvent)
    },
    onHoverEvent () {

    },
    onLeaveEvent () {

    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
